module.exports = __webpack_public_path__ + "img/assistance.161d5b58.svg";